import { render, staticRenderFns } from "./ChatPrivateSide.vue?vue&type=template&id=0a58476e&scoped=true"
import script from "./ChatPrivateSide.vue?vue&type=script&lang=js"
export * from "./ChatPrivateSide.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateSide.vue?vue&type=style&index=0&id=0a58476e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58476e",
  null
  
)

export default component.exports